import { Component, OnInit, Input, Renderer2, ViewChild, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UtilService, StorageService } from '../../../shared/services';

@Component({
  selector: 'app-sac-button',
  templateUrl: './sac-button.component.html',
  styleUrls: ['./sac-button.component.scss']
})
export class SacButtonComponent implements OnInit, OnDestroy {

  @Input() label = 'Start a Fundraiser';
  @Input() width;
  @Input() height;
  @Input() openLead;
  @Input() redirectSac;
  @ViewChild('leadForm', { static: true }) public leadForm;
  ExitlistenerFn: () => any;
  isFormSubmit;

  constructor(
    public dialog: MatDialog,
    private util: UtilService,
    private renderer: Renderer2,
    private storageService: StorageService
  ) { }

  ngOnInit() {
    this.ExitlistenerFn = this.exitIntent();
  }

  onClickListner(template) {
    if (this.openLead) {
      this.openLeadForm(template);
    }
    if (this.redirectSac) {
      this.util.router.navigate(['/new/crowdfunding/medical']);
    }
  }

  openLeadForm(template) {
    this.dialog.open(template, {
      maxHeight: '540px',
      width: '498px',
      panelClass: 'medical-sac-modal'
    });
  }

  exitIntent(): any {
    if (!this.storageService.getFromSession('exitDialogMedical')) {
      return this.renderer.listen('document', 'mouseout', (event) => {
        if (event.toElement == null && event.relatedTarget == null && event.clientY < 0) {
          if (this.storageService.getFromSession('exitDialogMedical') !== 'shown') {
            this.openLeadForm(this.leadForm);
            this.storageService.addSessionData('exitDialogMedical', 'shown');
          }
        }
      });
    }
  }

  ngOnDestroy() {
    if (this.ExitlistenerFn) {
      this.ExitlistenerFn();
    }
  }

}
